<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="dedication"></a><a id="page_v"><span class="txit">For my parents</span></a></p><a id="page_v">
<p class="ded1"><span class="txit">(and Schnippy, Chance, and Hund)</span></p>
</a><p class="ded1"><a id="page_v"><span class="txit">—A.M.R.</span></a><a id="page_vi"></a><a id="page_vii"></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7019277c